<table class="table table-sm table-list mb-4">
  <thead>
    <tr>
      <th colspan="2"
          scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <!-- Identifier -->
    <tr>
      <th title="The application’s ID."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">Identifier</th>
      <td>{{ installedApplication().identifier }}</td>
    </tr>

    <!-- Version -->
    <tr>
      <th title="The application’s version."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">Version</th>
      <td>{{ installedApplication().version }}</td>
    </tr>

    <!-- ShortVersion -->
    <tr>
      <th title="The application’s short version. Availability: Available in iOS 5.0 and later."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        Short version
      </th>
      <td>{{ installedApplication().shortVersion }}</td>
    </tr>

    <!-- Name -->
    <tr>
      <th title="The application’s name."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">Name</th>
      <td>{{ installedApplication().name }}</td>
    </tr>

    <!-- BundleSize -->
    <tr>
      <th title="The app’s static bundle size, in bytes."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        Bundle size
      </th>
      <td>
        {{
        installedApplication().bundleSize && installedApplication()?.bundleSize > 0
        ? (installedApplication()?.bundleSize | bytesToMb | number: '1.1-2') + ' MB'
        : 'N/A'
        }}
      </td>
    </tr>

    <!-- DynamicSize -->
    <tr>
      <th title="The size of the app’s document, library, and other folders, in bytes. Availability: Available in iOS 5.0 and later."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        Dynamic size
      </th>
      <td>
        {{
        installedApplication().dynamicSize && installedApplication()?.dynamicSize > 0
        ? (installedApplication()?.dynamicSize | bytesToMb | number: '1.1-2') + ' MB'
        : 'N/A'
        }}
      </td>
    </tr>

    <!-- Installing  -->
    <tr>
      <th title="If true, the app is being downloaded. Otherwise, it’s already installed on the device."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        Installing
      </th>
      <td>
        <ml-yes-no-icon [flag]="installedApplication().installing"></ml-yes-no-icon>
      </td>
    </tr>

    <!-- DownloadCancelled -->
    <tr>
      <th title="If true, the user canceled the download."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        Download Cancelled
      </th>
      <td>
        <ml-yes-no-icon [flag]="installedApplication().downloadCancelled"></ml-yes-no-icon>
      </td>
    </tr>

    <!-- DownloadFailed -->
    <tr>
      <th title="If true, the download failed."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        Download Failed
      </th>
      <td>
        <ml-yes-no-icon [flag]="installedApplication().downloadFailed"></ml-yes-no-icon>
      </td>
    </tr>

    <!-- DownloadPaused -->
    <tr>
      <th title="If true, the user paused the download."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        Download Paused
      </th>
      <td>
        <ml-yes-no-icon [flag]="installedApplication().downloadPaused"></ml-yes-no-icon>
      </td>
    </tr>

    <!-- DownloadWaiting -->
    <tr>
      <th title="If true, the app is in the initial state, which is waiting to download."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        Download Waiting
      </th>
      <td>
        <ml-yes-no-icon [flag]="installedApplication().downloadWaiting"></ml-yes-no-icon>
      </td>
    </tr>

    <!-- IsValidated -->
    <tr>
      <th title="If true, the app has validated as allowed to run and is able to run on the device. If an app is enterprise-distributed and is not validated, it will not run on the device until validated. Availability: Available in iOS 9.2 and later."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        Validated
      </th>
      <td>
        <ml-yes-no-icon [flag]="installedApplication().isValidated"></ml-yes-no-icon>
      </td>
    </tr>

    <!-- ExternalVersionIdentifier  -->
    <tr>
      <th title="The application’s external version ID. It can be used for comparison in the iTunes Search API to decide if the application needs to be updated. Availability: Available in iOS 11 and later."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        External Version Identifier
      </th>
      <td>{{ installedApplication().externalVersionIdentifier }}</td>
    </tr>

    <!-- AppStoreVendable -->
    <tr>
      <th title="If true, the app came from the store and can participate in store features. Availability: Available in iOS 11.3 and later."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        App Store Vendable
      </th>
      <td>
        <ml-yes-no-icon [flag]="installedApplication().appStoreVendable"></ml-yes-no-icon>
      </td>
    </tr>

    <!-- DeviceBasedVPP -->
    <tr>
      <th title="If true, the app is distributed to the device without requiring an Apple ID. Availability: Available in iOS 11.3 and later."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        Device Based VPP
      </th>
      <td>
        <ml-yes-no-icon [flag]="installedApplication().deviceBasedVPP"></ml-yes-no-icon>
      </td>
    </tr>

    <!-- BetaApp -->
    <tr>
      <th title="If true, the app is part of the Beta program. Availability: Available in iOS 11.3 and later."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        Beta App
      </th>
      <td>
        <ml-yes-no-icon [flag]="installedApplication().betaApp"></ml-yes-no-icon>
      </td>
    </tr>

    <!-- AdHocCodeSigned -->
    <tr>
      <th title="If true, the app is ad-hoc code signed. Availability: Available in iOS 11.3 and later."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        AdHoc Code Signed
      </th>
      <td>
        <ml-yes-no-icon [flag]="installedApplication().adHocCodeSigned"></ml-yes-no-icon>
      </td>
    </tr>

    <!-- HasUpdateAvailable -->
    <tr>
      <th title="If true, the app has an update available. This key will only be present for App Store apps. On macOS, this key will only be present for VPP apps. Availability: Available in iOS 11.3 and later and in macOS 10.13.4 and later."
          data-toggle="tooltip"
          data-placement="right"
          scope="row">
        Has Update Available
      </th>
      <td>
        <ml-yes-no-icon [flag]="installedApplication().hasUpdateAvailable"></ml-yes-no-icon>
      </td>
    </tr>
  </tbody>
</table>